import { Button, Tooltip } from 'antd';
import { HomeOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import style from './MapNavControls.module.css';
import { mapCenterPC } from '../../utils/mapbox-utils.js';

function MapNavControls() {
  const zoomHandle = (isIn) => {
    if (isIn) {
      window.map.flyTo({
        zoom: window.map.getZoom() + 1,
      });
    } else {
      window.map.flyTo({
        zoom: window.map.getZoom() - 1,
      });
    }
  };

  const zoomHome = () => {
    window.map.flyTo({
      center: mapCenterPC,
      zoom: 10,
    });
  };

  return (
    <div className={style.controls_wrapper}>
      <Tooltip title="Вернуться" placement="right">
        <Button
          onClick={zoomHome}
          icon={<HomeOutlined className={style.button_icon} />}
          className={style.button}
        />
      </Tooltip>
      <Tooltip title="Приблизить" placement="right">
        <Button
          onClick={() => zoomHandle(true)}
          icon={<PlusOutlined className={style.button_icon} />}
          className={style.button}
        />
      </Tooltip>
      <Tooltip title="Отдалить" placement="right">
        <Button
          onClick={() => zoomHandle(false)}
          icon={<MinusOutlined className={style.button_icon} />}
          className={style.button}
        />
      </Tooltip>
    </div>
  );
}

export default MapNavControls;
